export default __webpack_public_path__ + "static/automotive1-49318dd615329488d00f69ce41788554.jpeg";